module.exports = __webpack_public_path__ + "70a2e434359b261636b457663c97eedc.jpg";